import React from 'react'
import classNames from 'classnames'
import type { PainterAccountMenuClasses } from './usePainterAccountMenuStyles'

interface PainterAccountMenuItemProps {
  label: string
  icon: React.ComponentType<{ className?: string }>
  active?: boolean
  divider?: boolean
  onClick?: () => void
  classes: PainterAccountMenuClasses
}

export default function PainterAccountMenuItem(props: PainterAccountMenuItemProps) {
  const { label, icon: Icon, active, divider, onClick, classes } = props

  return (
    <button
      type="button"
      className={classNames(classes.item, active && classes.itemActive, divider && classes.itemDivider)}
      onClick={onClick}
    >
      <Icon className={classes.icon} />
      <span className={classes.label}>{label}</span>
    </button>
  )
}
